import React, { useEffect } from 'react'
import { columns} from '../../../constants/salarycardform.columns'
import { useFormContext, useFormState, useWatch } from 'react-hook-form'
import { Table } from '@shared/Table'
import { OrderSalaryCardType } from 'store/types/salaryCard'

function EmployeeTableForm() {
  const { control, trigger } = useFormContext<OrderSalaryCardType>();
  const { errors } = useFormState()
  
  const tableList = useWatch({ name: 'tableList', control })

  useEffect(() => {
    trigger()
  }, [tableList])

  const dataWithStatus = tableList.map((item, index) => {
    const rowErrors = errors?.tableList?.[index];
    return {
      ...item,
      status: !rowErrors ? 'valid': 'invalid',
    };
  });

  return (
      <Table
        tableKey="employeeTable"
        editable
        // virtual
        // pagination={false}
        pagination={{ defaultPageSize: 25, hideOnSinglePage: true }}
        editColumns={columns()}
        dataSource={dataWithStatus}
        rowKey={(record) => record.id} // ids
        selected={true}
        size='small'
        style={{ order: 2 }}
        scroll={{ x: 1500, y: 700 }}
      />
  )
}

export default EmployeeTableForm